import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLinkedinIn,
  faTwitter,
  faFacebookF,
  faInstagram,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import {
  faLocationDot,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
const Footer = () => {
  return (
    <>
      <div className="flex flex-col p-10 lg:p-20 lg:flex-row mt-20 gap-x-28 gap-y-20   lg:justify-center">
        <div className="flex flex-col  text-white w-full lg:w-[40%] ">
          <h1 className="font-bold text-2xl">
            Lotez Technologies Private Limited
          </h1>
          <p className="w-[90%] mt-5 sm:w-full lg:w-full">
            The ultimate technology development company where modern aesthetics
            effortlessly merge with user-centric design to elevate your product.
            At Lotez, we create innovative solutions that not only look great
            but also work seamlessly, making your product experience
            unforgettable.
          </p>
        </div>
        <div className="flex flex-col  text-white w-full lg:w-[10%]">
          <h1 className="font-bold text-2xl">Navigation</h1>
          <ul className="text-white mt-5 flex flex-col space-y-4 ">
            <li>
              <NavLink to="/">Home</NavLink>
            </li>
            <li>
              <NavLink to="/about">About</NavLink>
            </li>
            <li>
              <HashLink to="/#services">Services</HashLink>
            </li>
            <li>
              <NavLink to="/contact">Contact</NavLink>
            </li>
			<li>
              <NavLink to="/terms-and-conditions">Terms</NavLink>
            </li>
			<li>
              <NavLink to="/privacy-policy">Privacy Policy</NavLink>
            </li>
          </ul>
        </div>
        <div className="text-white w-full lg:w-[25%]">
          <h1 className="font-bold text-2xl">Contact Info</h1>
          <ul className="text-white flex flex-col mt-5 space-y-4">
            <li>
              <span className="mr-4">
                <FontAwesomeIcon icon={faLocationDot} />
              </span>
              Hyderabad, Telangana, India
            </li>
            <li>
              <span className="mr-4">
                <FontAwesomeIcon icon={faEnvelope} />
              </span>
              <a href="mailto:hello@lotez.in">hello@lotez.in</a>
            </li>
            <li>
              <span className="mr-4">
                <FontAwesomeIcon icon={faWhatsapp} />
              </span>
              <a href="tel:+918303541414">+91 6303541414</a>
            </li>
          </ul>
        </div>
        <div className="text-white w-full lg:w-[20%]">
          <h1 className="font-bold text-2xl">Follow Us</h1>
          <div className="flex flex-row mt-5 mb-5 space-x-4">
            <button className="rounded-full hover:bg-green hover:text-homeColor border-2 px-2 py-1">
              <a
                href="https://in.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faLinkedinIn}
                  style={{ color: '#ffffff' }}
                />
              </a>
            </button>
            <button className="rounded-full hover:bg-green hover:text-homeColor border-2 px-2 py-1">
              <a
                href="https://x.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faTwitter}
                  style={{ color: '#ffffff' }}
                />
              </a>
            </button>
            <button className="rounded-full hover:bg-green hover:text-homeColor border-2 px-3 py-1">
              <a
                href="https://facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faFacebookF}
                  style={{ color: '#ffffff' }}
                />
              </a>
            </button>
            <button className="rounded-full hover:bg-green hover:text-homeColor border-2 px-2 py-1">
              <a
                href="https://instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  style={{ color: '#ffffff' }}
                />
              </a>
            </button>
          </div>
          {/*<div className="flex flex-col gap-2">
              <NavLink to="/terms-and-conditions">Terms and Conditions</NavLink>
              <NavLink to="/privacy-policy">Privacy Policy</NavLink>
          </div>*/}
        </div>
      </div>
      <div className="flex justify-center text-white">
        <p>&copy; 2024
          <NavLink to="/terms-and-conditions"> Lotez </NavLink>All rights reserved.</p>
      </div>
    </>
  );
};
export default Footer;
